export enum ShipmentCustomsType {
  commercialInvoice = 'commercial_invoice',
  exportImportDocumentation = 'export_import_documentation',
  other = 'customs_other',
  packingList = 'packing_list',
}

export enum ShipmentDocumentType {
  custom = 'custom',
  invoice = 'invoice',
  other = 'other',
  photo = 'photo',
  pod = 'pod',
}
